/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum CustomerPersonRelationType {
    IsSelf = 'IsSelf',
    BruderSchwester = 'BruderSchwester',
    MutterVater = 'MutterVater',
    Ehepartner = 'Ehepartner',
    Lebensgefaehrte = 'Lebensgefaehrte',
    Kind = 'Kind',
    Verwandter = 'Verwandter',
    Sachwalter = 'Sachwalter',
    Ansprechperson = 'Ansprechperson',
    Manager = 'Manager',
    Buerge = 'Buerge',
    Ceo = 'Ceo',
    Vertriebsmitarbeiter = 'Vertriebsmitarbeiter',
    Gesellschafter = 'Gesellschafter',
    Anwalt = 'Anwalt',
    Sonstige = 'Sonstige'
  }

    export const CustomerPersonRelationTypeTranslocoMap: Record<CustomerPersonRelationType, string> = {
    [CustomerPersonRelationType.IsSelf]: 'customerPersonRelationType.isSelf',
    [CustomerPersonRelationType.BruderSchwester]: 'customerPersonRelationType.bruderSchwester',
    [CustomerPersonRelationType.MutterVater]: 'customerPersonRelationType.mutterVater',
    [CustomerPersonRelationType.Ehepartner]: 'customerPersonRelationType.ehepartner',
    [CustomerPersonRelationType.Lebensgefaehrte]: 'customerPersonRelationType.lebensgefaehrte',
    [CustomerPersonRelationType.Kind]: 'customerPersonRelationType.kind',
    [CustomerPersonRelationType.Verwandter]: 'customerPersonRelationType.verwandter',
    [CustomerPersonRelationType.Sachwalter]: 'customerPersonRelationType.sachwalter',
    [CustomerPersonRelationType.Ansprechperson]: 'customerPersonRelationType.ansprechperson',
    [CustomerPersonRelationType.Manager]: 'customerPersonRelationType.manager',
    [CustomerPersonRelationType.Buerge]: 'customerPersonRelationType.buerge',
    [CustomerPersonRelationType.Ceo]: 'customerPersonRelationType.ceo',
    [CustomerPersonRelationType.Vertriebsmitarbeiter]: 'customerPersonRelationType.vertriebsmitarbeiter',
    [CustomerPersonRelationType.Gesellschafter]: 'customerPersonRelationType.gesellschafter',
    [CustomerPersonRelationType.Anwalt]: 'customerPersonRelationType.anwalt',
    [CustomerPersonRelationType.Sonstige]: 'customerPersonRelationType.sonstige',
    };

    export const CustomerPersonRelationTypeOptions = [
  { value: CustomerPersonRelationType.IsSelf, labelKey: 'customerPersonRelationType.isSelf' },
  { value: CustomerPersonRelationType.BruderSchwester, labelKey: 'customerPersonRelationType.bruderSchwester' },
  { value: CustomerPersonRelationType.MutterVater, labelKey: 'customerPersonRelationType.mutterVater' },
  { value: CustomerPersonRelationType.Ehepartner, labelKey: 'customerPersonRelationType.ehepartner' },
  { value: CustomerPersonRelationType.Lebensgefaehrte, labelKey: 'customerPersonRelationType.lebensgefaehrte' },
  { value: CustomerPersonRelationType.Kind, labelKey: 'customerPersonRelationType.kind' },
  { value: CustomerPersonRelationType.Verwandter, labelKey: 'customerPersonRelationType.verwandter' },
  { value: CustomerPersonRelationType.Sachwalter, labelKey: 'customerPersonRelationType.sachwalter' },
  { value: CustomerPersonRelationType.Ansprechperson, labelKey: 'customerPersonRelationType.ansprechperson' },
  { value: CustomerPersonRelationType.Manager, labelKey: 'customerPersonRelationType.manager' },
  { value: CustomerPersonRelationType.Buerge, labelKey: 'customerPersonRelationType.buerge' },
  { value: CustomerPersonRelationType.Ceo, labelKey: 'customerPersonRelationType.ceo' },
  { value: CustomerPersonRelationType.Vertriebsmitarbeiter, labelKey: 'customerPersonRelationType.vertriebsmitarbeiter' },
  { value: CustomerPersonRelationType.Gesellschafter, labelKey: 'customerPersonRelationType.gesellschafter' },
  { value: CustomerPersonRelationType.Anwalt, labelKey: 'customerPersonRelationType.anwalt' },
  { value: CustomerPersonRelationType.Sonstige, labelKey: 'customerPersonRelationType.sonstige' },
    ];

